import React from 'react';
import classNames from 'classnames';

import ActSvg from '@svg/product/act.svg';
import AmcSvg from '@svg/product/amc.svg';
import CltSvg from '@svg/product/clt.svg';
import GreSvg from '@svg/product/gre.svg';
import InsuranceLifeHealthSvg from '@svg/product/insurance-life-health.svg';
import SieSvg from '@svg/product/sie.svg';
import Series6Svg from '@svg/product/series-6.svg';
import Series7Svg from '@svg/product/series-7.svg';
import Series9Svg from '@svg/product/series-9.svg';
import Series63Svg from '@svg/product/series-63.svg';
import Series65Svg from '@svg/product/series-65.svg';
import Series66Svg from '@svg/product/series-66.svg';
import UsmleSvg from '@svg/product/usmle.svg';
import { slugToCamelCase } from '@lib/helpers';

import * as styles from './styles.module.scss';

const PRODUCT_SVG_MAP = {
  act: ActSvg,
  'amc-8': AmcSvg,
  'amc-10': AmcSvg,
  'amc-12': AmcSvg,
  'amc-8-10-12': AmcSvg,
  clt: CltSvg,
  'finra-sie': SieSvg,
  'finra-series-6': Series6Svg,
  'finra-series-7': Series7Svg,
  'finra-series-9': Series9Svg,
  'finra-series-63': Series63Svg,
  'finra-series-65': Series65Svg,
  'finra-series-66': Series66Svg,
  gre: GreSvg,
  'insurance-life-health': InsuranceLifeHealthSvg,
  'usmle-step-1': UsmleSvg,
  default: SieSvg,
};

const ProductSvg = (props) => {
  const { className, inverted, product } = props;
  const productStyle = slugToCamelCase(product);
  const Svg = PRODUCT_SVG_MAP[product] || PRODUCT_SVG_MAP.default;

  return (
    <Svg
      className={classNames(
        styles.layout,
        styles[productStyle],
        inverted && styles.inverted,
        className
      )}
    />
  );
};

export default ProductSvg;
